import { useRef, useCallback } from "react";
import { api } from "@/lib/api";

export function useTrackOnce(tool) {
  const tracked = useRef(false);
  return useCallback(() => {
    if (tracked.current) return;
    tracked.current = true;
    api.post("/track", { tool }).catch(() => {});
  }, [tool]);
}
